import React from 'react';
import { Box, Typography, Container, Link } from '@mui/material';

const PublicFooter: React.FC = () => {
  return (
    <Box 
      component="footer" 
      sx={{ 
        bgcolor: 'primary.main', 
        color: 'white', 
        py: 3, 
        mt: 'auto' 
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
          <Typography variant="body2">
            © 2024 PalmGarden Reforestation. All rights reserved.
          </Typography>
          
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Link 
              href="/privacy" 
              color="inherit" 
              sx={{ textDecoration: 'none' }}
            >
              Privacy Policy
            </Link>
            <Link 
              href="/terms" 
              color="inherit" 
              sx={{ textDecoration: 'none' }}
            >
              Terms of Service
            </Link>
            <Link 
              href="/contact" 
              color="inherit" 
              sx={{ textDecoration: 'none' }}
            >
              Contact Us
            </Link>
          </Box>
        </Box>
        
        <Typography variant="body2" sx={{ mt: 2, textAlign: 'center' }}>
          Dedicated to restoring Malaysia's natural ecosystems through sustainable palm cultivation.
        </Typography>
      </Container>
    </Box>
  );
};

export default PublicFooter; 